<template>
  <div v-if="data">
    <div class="title product">
      <h1>{{ $t("商品信息") }}</h1>
    </div>
    <div class="flex items-center justify-start">
      <span class="iconfont icon-q07 text-orange-500 pr-1 pb-1"></span>
      {{ data.supplier_name }}
    </div>
    <div class="title2 base ">
      <p>{{ $t("商品") }}</p>
      <p>{{ $t("参数") }}</p>
      <p>{{ $t("数量") }}</p>
      <p>{{ $t("单价") }}</p>
      <p>{{ $t("优惠") }}</p>
      <p>{{ $t("小计") }}</p>
    </div>
    
    <div v-for="tr in data.items" :key="tr.id" class="base bd">
      <div class="p-4 item">
        <OrderItem :item="tr"></OrderItem>
      </div>
      <div class="params">
        <p class="space-x-4">
          <span>{{ tr.product.attribute_text }}</span>
        </p>
        <!-- <p class="space-x-4">
          <span>中熟</span>
          <span>50cm</span>
          <span>黄色</span>
        </p> -->
      </div>
      <p>{{ tr.quantity }}</p>
      <p class=" text-red-500">{{ $p(tr.price) }}</p>
      <p class=" text-green-500">{{ $p(0) }}</p>
      <p class="">
        {{ $p(tr.sumprice) }}
      </p>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-dom"
import OrderItem from "@/components/base/orderItem.vue"

export default defineComponent({
  components: { OrderItem },
  props: { data: Object },
  setup() {
    return {}
  },
})
</script>

<style scoped lang="scss">.title {
  text-align: start;
}
.title > h1 {
  font-size: 1.125rem;
  margin-bottom: 1rem;
  font-weight: bold;
}
.title > p {
  margin-bottom: 0.5rem;
}
.base {
  display: grid;
  grid-template-columns: 4fr 2fr repeat(4, 1fr);
}
.title2 {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
  border-width: 1px;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.bd {
  border-width: 1px;
  border-top-width: 0px;
}
.bd > p, .bd .params {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  border-left-width: 1px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
}</style>
